module.exports = __webpack_public_path__ + "ptc_momoro_N2.6744af28.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/momoro/parent_to_child/ptc_momoro_N2.jpg
// module id = d/h7
// module chunks = 0